import React from 'react';
import styled from 'styled-components';
import { TypographyComponent as TypographyElement, BrandLogos } from '@tvg/fuse-design';
import useWindowSize from 'hooks/useWindowSize';

const OptionsHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  @media (max-width: 820px) {
    flex-direction: column;
  }
`;
const OptionHeaderText = styled(TypographyElement)`
  @media (max-width: 370px) {
    font-size: 14px;
  }
`;
const OptionsHeaderLogo = styled(BrandLogos)`
  position: relative;
  top: 2px;
  margin-left: 4px;
`;
function PaymentOptionsHeader() {
  const windowSize = useWindowSize();

  return (
    <OptionsHeaderContainer role="heading" aria-level={2} aria-label="A choice of ways to pay with Very Pay">
      <OptionHeaderText size="3" tag="h3" type="display">
        A choice of ways to pay with
      </OptionHeaderText>
      <OptionsHeaderLogo brand="VeryPay" width={windowSize.width < 370 ? 64 : 86} alt="Very Pay" />
    </OptionsHeaderContainer>
  );
}

export default PaymentOptionsHeader;
